import { useNavigate } from "react-router-dom";
import {
  Compass, Gem, Layers, Flame, LayoutGrid, Bookmark, Clock,
} from "lucide-react";
import { Layout } from "../components/Layout";
import { HubCard } from "../components/HubCard";
import { PageRocket } from "../components/PageRocket";

export default function DiscoveryHub() {
  const navigate = useNavigate();

  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="flex items-start justify-between gap-6 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37]/12 px-4 py-1.5 text-xs font-semibold text-[#B8901F] mb-4">
              🔎 Discovery Hub
            </div>
            <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-[#0F0F0F]">
              Let's Discover
            </h1>
            <p className="text-[#687280] mt-3 max-w-xl">
              Discover your next startup opportunity. Explore curated ideas, proven models, and
              trending opportunities.
            </p>
          </div>
          <PageRocket className="w-36 lg:w-52 -mt-2" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <HubCard
            icon={Compass}
            title="Explore Ideas"
            subtitle="Browse the full library of curated business ideas."
            items={["Browse by Category"]}
            onClick={() => navigate("/business-ideas")}
            index={0}
          />
          <HubCard
            icon={Gem}
            title="Founder Vault"
            subtitle="Premium, high-potential business opportunities."
            items={["Browse Premium Ideas"]}
            onClick={() => navigate("/categories/founder-vault")}
            index={1}
          />
          <HubCard
            icon={Layers}
            title="Proven Business Models"
            subtitle="Battle-tested models to adapt for your niche."
            items={["Shopify For X", "Uber For X", "Airbnb For X", "Million-Dollar Apps", "Subscriptions"]}
            onClick={() => navigate("/categories/million-dollar-models")}
            index={2}
          />
          <HubCard
            icon={Flame}
            title="Trending Opportunities"
            subtitle="See what founders are exploring right now."
            items={["Community Upvoted", "Ranked Live"]}
            onClick={() => navigate("/trending")}
            index={3}
          />
          <HubCard
            icon={LayoutGrid}
            title="Categories"
            subtitle="Explore ideas by industry."
            items={["40 Categories"]}
            onClick={() => navigate("/categories")}
            index={4}
          />
          <HubCard
            icon={Bookmark}
            title="Saved Ideas & Favorites"
            subtitle="Everything you've saved in your Startup Notebook."
            onClick={() => navigate("/notebook")}
            index={5}
          />
          <HubCard
            icon={Clock}
            title="New This Week"
            subtitle="Recently added business opportunities."
            onClick={() => navigate("/business-ideas")}
            index={6}
          />
        </div>
      </section>
    </Layout>
  );
}
